export default __webpack_public_path__ + "static/screeny-55-gp-xs-5-e4bad497f928b8e63a4fe6f2006b46ba.jpg";